module.exports = __webpack_public_path__ + "static/media/21_A.97937f20.png";